import { HttpStatusCode } from 'axios';
import { useEffect, useState } from 'react';
import { DealWithLocations } from '../../../../../types/apiTypes';
import { VendorBusinessLocation } from '../../../../../types/dbTypes';
import useApi from '../../../../../utils/AxiosWrapper';
import { useScreenView } from '../../../../../utils/ScreenViewContext';
import { useUser } from '../../../../../utils/UserContext';
import BusinessLocations from './widgets/BusinessLocations';
import GetStartedVendorsWidget from './widgets/GetStartedVendorsWidget';
import MetricsWidget from './widgets/MetricsWidget';
import PromotionsWidget from './widgets/PromotionsWidget';

interface VendorHomeProps {
  userType: string;
  currentPage: string;
  currentTab: string;
  setCurrentTab: (tab: string) => void;
  subTab: string;
  setSubTab: (tab: string) => void;
}

function VendorHome({
  userType,
  currentPage,
  currentTab,
  setCurrentTab,
  subTab,
  setSubTab,
}: VendorHomeProps) {
  const { screenView } = useScreenView();

  const { userId } = useUser();
  const [loadingLocations, setLoadingLocations] = useState<boolean>(false);
  const [businessLocations, setBusinessLocations] = useState<
    VendorBusinessLocation[]
  >([]);
  const { callProtectedApi } = useApi();
  const [loadingDeals, setLoadingDeals] = useState<boolean>(false);
  const [deals, setDeals] = useState<DealWithLocations[]>([]);
  useEffect(() => {
    const fetchBusinessLocationsForVendor = async (vendor_id: string) => {
      setLoadingLocations(true);
      try {
        const response = await callProtectedApi(
          `/vendorBusinessLocations/list/${vendor_id}`,
          'get',
          {},
          'Error occurred while fetching your business locations.'
        );
        const data = response?.data?.data?.vendorBusinessLocations;
        if (
          data &&
          data?.length > 0 &&
          response?.status === HttpStatusCode.Ok
        ) {
          setBusinessLocations(data);
        }
      } catch (e: any) {
        console.error(
          'Error occurred while fetching your vendor business locations: ',
          e
        );
      } finally {
        setLoadingLocations(false);
      }
    };

    fetchBusinessLocationsForVendor(userId ?? '');

    const fetchDealsForVendor = async (vendor_id: string) => {
      setLoadingDeals(true);
      try {
        const response = await callProtectedApi(
          `/deals/list/${vendor_id}`,
          'get',
          {},
          'Error occurred while fetching your promotions.'
        );
        const data = response?.data?.data?.deals;
        if (
          data &&
          data?.length > 0 &&
          response?.status === HttpStatusCode.Ok
        ) {
          setDeals(data);
        }
      } catch (e: any) {
        console.error('Error occurred while fetching your promotions: ', e);
      } finally {
        setLoadingDeals(false);
      }
    };

    fetchDealsForVendor(userId ?? '');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderScreenView = (screenView: string) => {
    switch (screenView) {
      case 'desktop':
      case 'tablet':
      case 'mobile':
        return (
          <div className="overflow-y-auto overflow-x-hidden px-4 sm:w-[95%] md:w-full lg:w-[1148px] lg:max-w-[1148px] lg:px-0">
            <div className="flex h-full w-full flex-col space-y-[16px] py-[16px] pb-12">
              <div className="flex w-full flex-row">
                <GetStartedVendorsWidget
                  promotionCount={deals?.length}
                  locationCount={businessLocations?.length}
                />
              </div>
              <div className="flex w-full flex-row">
                <MetricsWidget />
              </div>
              <div className="flex w-full flex-row">
                <PromotionsWidget
                  loadingPromotions={loadingDeals}
                  promotions={deals}
                />
              </div>
              <div className="flex w-full flex-row">
                <BusinessLocations
                  loadingLocations={loadingLocations}
                  locations={businessLocations}
                />
              </div>
              <div className="flex w-full flex-row gap-x-[16px]"></div>
            </div>
          </div>
        );
    }
  };
  return <>{renderScreenView(screenView)}</>;
}

export default VendorHome;
